import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  searchPresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/templates/search/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const searchPresentations = (params) => {
  return resource.searchPresentations(params)
}

export default {
  initResource,
  searchPresentations,
}
